import { render, staticRenderFns } from "./toolbar-item.vue?vue&type=template&id=708d306a"
import script from "./toolbar-item.vue?vue&type=script&lang=js"
export * from "./toolbar-item.vue?vue&type=script&lang=js"
import style0 from "./toolbar-item.vue?vue&type=style&index=0&id=708d306a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports